<div class="assetLibraryContainer">
    <!-- <div class="banner">
    </div> -->
    <nav *ngIf="!data.isModal" aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a (click)="goHome()">Home</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
                Asset Library
            </li>
        </ol>
    </nav>
      
    <div class="assetLibraryCardContainer">
        <ng-container *ngFor="let assetData of assetLibraries">
            <div class="assetLibraryCard">
                <div class="ALCardBanner" [ngStyle]="{'background': 'url(' + assetData.headerImageUrl + ') no-repeat center center'}">
                    <p class="ALYellowLabel">{{assetData.assetCategory}}</p>
                    <p class="ALBlueLabel">{{assetData.assetSubCategory}}</p>
                </div>
                <div class="ALCardContent">
                    <div class="ALHeader">
                        {{assetData.assetName}}
                    </div>
                    <div class="color-div"></div>
                    <div class="ALContent" [title]="assetData.assetDescription">
                       <span>
                            {{assetData.assetDescription}}
                       </span>
                    </div>
                    <div class="ALContent2">
                        <div>
                            <span class="ALlabel">Service Line</span>
                            <span class="ALvalue"> {{assetData.serviceLine}} </span>
                        </div>
                        <div>
                            <span class="ALlabel">Competency</span>
                            <span class="ALvalue"> {{assetData.competency}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
  